// @mui
import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

type BgBlurProps = {
  blur?: number;
  color?: string;
  imgUrl?: string;
  opacity?: number;
};

export const bgBlur = (props?: BgBlurProps) => {
  const color = props?.color || '#000000';
  const blur = props?.blur || 6;
  const opacity = props?.opacity || 0.8;
  const imgUrl = props?.imgUrl;

  if (imgUrl) {
    return {
      '&:before': {
        backdropFilter: `blur(${blur}px)`,
        backgroundColor: alpha(color, opacity),
        content: '""',
        height: '100%',
        left: 0,
        position: 'absolute',
        top: 0,
        WebkitBackdropFilter: `blur(${blur}px)`,
        width: '100%',
        zIndex: 9,
      },
      backgroundImage: `url(${imgUrl})`,
      position: 'relative',
    } as const;
  }

  return {
    backdropFilter: `blur(${blur}px)`,
    backgroundColor: alpha(color, opacity),
    WebkitBackdropFilter: `blur(${blur}px)`,
  };
};

// ----------------------------------------------------------------------

type BgGradientProps = {
  color?: string;
  direction?: string;
  endColor?: string;
  imgUrl?: string;
  startColor?: string;
};

export const bgGradient = (props?: BgGradientProps) => {
  const direction = props?.direction || 'to bottom';
  const startColor = props?.startColor;
  const endColor = props?.endColor;
  const imgUrl = props?.imgUrl;
  const color = props?.color;

  if (imgUrl) {
    return {
      background: `linear-gradient(${direction}, ${startColor || color}, ${
        endColor || color
      }), url(${imgUrl})`,
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
    };
  }

  return {
    background: `linear-gradient(${direction}, ${startColor}, ${endColor})`,
  };
};

// ----------------------------------------------------------------------

export const textGradient = (value: string) => {
  return {
    background: `-webkit-linear-gradient(${value})`,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  };
};

// ----------------------------------------------------------------------

export const filterStyles = (value: string) => {
  return {
    filter: value,
    MozFilter: value,
    WebkitFilter: value,
  };
};

// ----------------------------------------------------------------------

export const hideScrollbarY = {
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  msOverflowStyle: 'none',
  overflowY: 'scroll',
  scrollbarWidth: 'none',
} as const;

// ----------------------------------------------------------------------

export const hideScrollbarX = {
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  msOverflowStyle: 'none',
  overflowX: 'scroll',
  scrollbarWidth: 'none',
} as const;
